import * as React from "react";
const SvgArrowRightSmall = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.875 6H10.125M10.125 6L6.75 2.625M10.125 6L6.75 9.375", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgArrowRightSmall;
